<!-- Just an image -->
<nav class="navbar navbar-inverse bg-dark">
  <a class="navbar-brand" href="#">
    <img
      src="../../assets/images/2.png"
      class="ms-3"
      width="80"
      height="50"
      alt=""
    />
  </a>
</nav>
<div class="control-section mt-5 me-3">
  <img
    class="rounded mx-auto d-block"
    src="../../assets/images/unauthorizedSymbol.png"
    alt=""
  />
  <p class="h3 text-center text-primary mt-5">401-Unauthorized</p>
  <p class="h6 text-center text-primary">
    Your authorization failed.<br />
    Please contact your admin for more details.
  </p>
  <p class="h6 text-dark text-center">OR</p>
  <div class="row text-center">
    <div class="mx-auto">
      <a class="btn btn-link" (click)="check()">TryAgain</a>
      <a class="btn btn-outline-primary ms-2" (click)="login()">logout</a>
    </div>
  </div>
</div>
